import {
  Calculator,
  ClipboardCheck,
  Compass,
  MessageSquare,
  Palmtree,
  Scale,
  Search,
  SearchCheck,
  ShieldCheck,
} from 'lucide-react';

/**
 * Zentrale Konfiguration aller Portal-Ressourcen.
 * requiresLogin: false → Tool ohne Konto nutzbar (z. B. nur PDF-Export, keine Server-Speicherung).
 */
export const RESOURCES = [
  {
    id: 'gehaltsrechner',
    path: '/resources/gehaltsrechner',
    requiresLogin: true,
    title: 'Gehaltsrechner',
    description: 'Vereinfachte Brutto-zu-Netto-Schätzung für die Orientierung',
    icon: Calculator,
    iconColor: 'text-hrf-navy',
    iconBg: 'bg-hrf-navy/10',
    showInOverview: true,
  },
  {
    id: 'urlaubsrechner',
    path: '/resources/urlaubsrechner',
    requiresLogin: true,
    title: 'Urlaubsanspruch',
    description: 'Resturlaub aus Anspruch, Vorjahr und bereits genommenen Tagen',
    icon: Palmtree,
    iconColor: 'text-emerald-600',
    iconBg: 'bg-emerald-500/10',
    showInOverview: true,
  },
  {
    id: 'selbstcheck-compliance',
    path: '/resources/selbstcheck-compliance',
    requiresLogin: true,
    title: 'Selbstcheck Compliance',
    description: 'Kurz-Check zu Dokumentation und sensiblen HR-Themen',
    icon: ShieldCheck,
    iconColor: 'text-violet-600',
    iconBg: 'bg-violet-500/10',
    showInOverview: true,
  },
  {
    id: 'entgelttransparenz',
    path: '/resources/entgelttransparenz',
    requiresLogin: true,
    title: 'Entgelttransparenz',
    description: 'Stellenbeschreibungen nach EU 2023/970 – KI-geführt',
    icon: Scale,
    iconColor: 'text-rose-600',
    iconBg: 'bg-rose-500/10',
    showInOverview: true,
  },
  {
    id: 'entscheidungs-assistent',
    path: '/resources/entscheidungs-assistent',
    requiresLogin: false,
    title: 'HR-Kompass',
    description: 'HR-Entscheidung in wenigen Minuten – Build, Borrow oder Buy',
    icon: Compass,
    iconColor: 'text-hrf-navy',
    iconBg: 'bg-hrf-navy/10',
    showInOverview: false,
  },
  {
    id: 'hr-selbstcheck',
    path: '/resources/hr-selbstcheck',
    requiresLogin: true,
    title: 'HR Selbstcheck',
    description: 'Strukturierter Selbstcheck für HR-Themen',
    icon: ClipboardCheck,
    iconColor: 'text-hrf-navy',
    iconBg: 'bg-hrf-navy/10',
    showInOverview: false,
  },
  {
    id: 'hr-self-service-chatbot',
    path: '/resources/hr-self-service-chatbot',
    requiresLogin: true,
    title: 'HR Self-Service Chatbot',
    description: 'Antworten aus dem HR-Handbuch per Chat',
    icon: MessageSquare,
    iconColor: 'text-hrf-navy',
    iconBg: 'bg-hrf-navy/10',
    showInOverview: false,
  },
  {
    id: 'ki-recruiting',
    path: '/resources/ki-recruiting',
    requiresLogin: true,
    title: 'KI-Recruiting',
    description: 'Recruiting-Unterstützung mit KI',
    icon: Search,
    iconColor: 'text-hrf-navy',
    iconBg: 'bg-hrf-navy/10',
    showInOverview: false,
  },
  {
    id: 'frag-einen-expert',
    path: '/resources/frag-einen-expert',
    requiresLogin: true,
    title: 'Frag einen Expert',
    description: 'Frage an den zuständigen Account Manager',
    icon: SearchCheck,
    iconColor: 'text-hrf-navy',
    iconBg: 'bg-hrf-navy/10',
    showInOverview: false,
  },
  {
    id: 'einladung-erstellen',
    path: '/resources/einladung-erstellen',
    requiresLogin: true,
    title: 'Einladung erstellen',
    description: 'Neue Portal-Einladung versenden (intern)',
    icon: SearchCheck,
    iconColor: 'text-hrf-navy',
    iconBg: 'bg-hrf-navy/10',
    showInOverview: false,
  },
];

/** Karten in der Ressourcen-Übersicht (subset). */
export const RESOURCE_ITEMS = RESOURCES.filter((item) => item.showInOverview);

export function getResourceByPath(pathname) {
  return RESOURCES.find((item) => item.path === pathname) || null;
}

/** Öffentlich ohne Login erreichbar? */
export function isPublicResourcePath(pathname) {
  const resource = getResourceByPath(pathname);
  return Boolean(resource && !resource.requiresLogin);
}

/** Unbekannte Pfade gelten als login-pflichtig. */
export function resourceRequiresLogin(pathname) {
  const resource = getResourceByPath(pathname);
  if (!resource) return true;
  return resource.requiresLogin;
}
